import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2, RefreshCw } from 'lucide-react';
import { Button } from './button';

interface PageLoaderProps {
  /** Tempo em ms para mostrar sugestão de refresh (default: 5000) */
  timeoutMs?: number;
  /** Desabilita completamente o timeout e sugestão de refresh */
  disableTimeout?: boolean;
}

export function PageLoader({ timeoutMs = 5000, disableTimeout = false }: PageLoaderProps) {
  const [showRefreshHint, setShowRefreshHint] = useState(false);

  useEffect(() => {
    // Se timeout desabilitado, não mostrar sugestão de refresh
    if (disableTimeout) return;

    const timer = setTimeout(() => {
      setShowRefreshHint(true);
    }, timeoutMs);

    return () => clearTimeout(timer);
  }, [timeoutMs, disableTimeout]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col items-center gap-4"
      >
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Carregando...</p>

        <AnimatePresence>
          {showRefreshHint && (
            <motion.div
              initial={{ opacity: 0, y: 10, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -10, scale: 0.95 }}
              transition={{ duration: 0.3 }}
              className="mt-4 p-4 rounded-lg border border-yellow-500/30 bg-yellow-500/10 backdrop-blur-sm max-w-sm text-center"
            >
              <p className="text-sm text-yellow-200 mb-3">
                O carregamento está demorando mais que o esperado.
              </p>
              <Button
                variant="outline"
                size="sm"
                onClick={handleRefresh}
                className="gap-2 border-yellow-500/30 hover:bg-yellow-500/20 hover:border-yellow-500/50"
              >
                <RefreshCw className="h-4 w-4" />
                Atualizar página
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
}
